import React from "react";
import Header from "../general/Header";
import Aside from "../general/Aside";
import Footer from "../general/Footer";
import axios from "../../axios/axiosconf";
import { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { Link } from "react-router-dom";
import ModalForm from "../general/ModalForm";
import Loading from "../general/Loading";

function ParametrosRips() {

    const [loading, setLoading] = useState(false);
    const [loggedIn, setLoggedIn] = useState(false);
    const [client, setClient] = useState([]);

    const [razonSocial, setRazonSocial] = useState();
    const [codigoRegistro, setCodigoRegistro] = useState();
    const [nit, setNit] = useState();
    const [direccion, setDireccion] = useState();
    const [telefono, setTelefono] = useState();
    const [director, setDirector] = useState();
    const [telefonoContacto, setTelefonoContacto] = useState();
    const [codigoEntidad, setCodigoEntidad] = useState();
    const [entidad, setEntidad] = useState();
    const [parametrosId, setParametrosId] = useState();

    const [errorlist, setErrorlist] = useState({});
    
    const [parametrosExisten, setParametrosExisten] = useState(false);

    let history = useHistory();

    let userdata = [];
    let clientData = [];
    let rolePermissions = [];


    useEffect(()=>{

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            }
        }

        
        axios.get('/get-client?uid='+userdata.user_id, config)
            .then(response => {
                if (response.status===200) {
                    
                    setClient(response.data);
                    setLoggedIn(true);
                }
            })
            .catch(error => {
                
                console.log(error);
            });

        axios.get('parametros-rips?uid='+userdata.user_id,config)
            .then(response => {
                console.log(response.data);
                if (response.data) {
                    setParametrosExisten(true);
                    setParametrosId(response.data.id);
                    setRazonSocial(response.data.razon_social);
                    setCodigoRegistro(response.data.codigo_registro);
                    setNit(response.data.nit);
                    setDireccion(response.data.direccion);
                    setTelefono(response.data.telefono);
                    setDirector(response.data.director);
                    setTelefonoContacto(response.data.telefono_contacto);
                    setCodigoEntidad(response.data.codigo_entidad);
                    setEntidad(response.data.entidad);
                }
            })
            .catch(error => console.log(error.response.data))
        
    },[]);


    const handleSubmit = (e) => {
        e.preventDefault();
        setLoading(true);

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const conf = {
            headers: { Authorization: 'Bearer ' + userdata.access_token },
            client_id: client.client_id,
            razon_social: razonSocial,
            codigo_registro: codigoRegistro,
            nit: nit,
            direccion: direccion,
            telefono: telefono,
            director: director,
            telefono_contacto: telefonoContacto,
            codigo_entidad: codigoEntidad,
            entidad: entidad
        };
        
        if (parametrosExisten) {
            conf.id = parametrosId;
            axios.put('/parametros-rips', conf)
                .then(
                    response => {
                        setLoading(false);
                        localStorage.setItem('toastmsg', 'Los Parámetros Para Informe RIPS Han Sido Modificados');
                        history.push('/administrar-rips');
                    }
                )
                .catch(
                    err => {
                        setErrorlist(err.response.data.errors);
                        setLoading(false);
                    }
                )
        }
        else {
            axios.post('/parametros-rips', conf)
                .then(
                    response => {
                        setLoading(false);
                        localStorage.setItem('toastmsg', 'Los Parámetros Para Informe RIPS Han Sido Creados');
                        history.push('/administrar-rips');
                    }
                )
                .catch(
                    err => {
                        setErrorlist(err.response.data.errors);
                        setLoading(false);
                    }
                )
        }
        
    }


    if (loggedIn) {
        return (
            
            <div className="hold-transition">
                <Header client={client} />
                <Aside client={client} activelink="settings" />
                
                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-8">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item" key="bc1"><Link to="/home">Home</Link></li>
                                        <li className="breadcrumb-item" key="bc2"><Link to="/settings">Configuración</Link></li>
                                        <li className="breadcrumb-item" key="bc3"><Link to="/administrar-rips">Administrar RIPS</Link></li>
                                        <li className="breadcrumb-item" key="bc4">Crear Parámetros RIPS</li>
                                    </ol>
                                </div>
                            </div>
                            <div className="row mb-2">
                                <div className="col-sm-8">
                                    <h1 className="m-0">Parámetros RIPS</h1>
                                </div>
                            </div>
                        </div>
                    </div>
                    <section className="content" >
                        <div className="container-fluid">

                            <div className="row">
                            <div className="col-md-10">
                                
                                <div className="card">
                                <div id="infobasica">
                                    <div className="card-body">

    

                                        <form id="role-form" onSubmit={handleSubmit}>
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <div className="form-group">
                                                        <label>Nombre o Razón Social Profesional Independiente / IPS</label>
                                                        <input type="text" name="razon" className="form-control" id="razon" value={razonSocial} onChange={(e) => setRazonSocial(e.target.value)} autoFocus />
                                                        <div className="invalid-feedback visible">
                                                        {errorlist.razon_social}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-12">
                                                    <div className="form-group">
                                                        <label>Codigo de Habilitacion</label>
                                                        <input type="text" name="codigo" className="form-control" id="codigo" value={codigoRegistro} onChange={(e) => setCodigoRegistro(e.target.value)} />
                                                        <div className="invalid-feedback visible">
                                                        {errorlist.codigo_registro}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-12">
                                                    <div className="form-group">
                                                        <label>Identificacion</label>
                                                        <input type="text" name="nit" className="form-control" id="nit" value={nit} onChange={(e) => setNit(e.target.value)} />
                                                        <div className="invalid-feedback visible">
                                                        {errorlist.nit}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-12">
                                                    <div className="form-group">
                                                        <label>Dirección</label>
                                                        <input type="text" name="direccion" className="form-control" id="direccion" value={direccion} onChange={(e) => setDireccion(e.target.value)} />
                                                        <div className="invalid-feedback visible">
                                                        {errorlist.direccion}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-12">
                                                    <div className="form-group">
                                                        <label>Teléfono</label>
                                                        <input type="text" name="telefono" className="form-control" id="telefono" value={telefono} onChange={(e) => setTelefono(e.target.value)} />
                                                        <div className="invalid-feedback visible">
                                                        {errorlist.telefono}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-12">
                                                    <div className="form-group">
                                                        <label>Sede</label>
                                                        <input type="text" name="director" className="form-control" id="director" value={director} onChange={(e) => setDirector(e.target.value)} />
                                                        <div className="invalid-feedback visible">
                                                        {errorlist.director}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-12">
                                                    <div className="form-group">
                                                        <label>Celular</label>
                                                        <input type="text" name="telefono_contacto" className="form-control" id="telefono_contacto" value={telefonoContacto} onChange={(e) => setTelefonoContacto(e.target.value)} />
                                                        <div className="invalid-feedback visible">
                                                        {errorlist.telefono_contacto}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-12">
                                                    <div className="form-group">
                                                        <label>Código Sede</label>
                                                        <input type="text" name="codigo_entidad" className="form-control" id="codigo_entidad" value={codigoEntidad} onChange={(e) => setCodigoEntidad(e.target.value)} />
                                                        <div className="invalid-feedback visible">
                                                        {errorlist.codigo_entidad}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-12">
                                                    <div className="form-group">
                                                        <label>Codigo SYSPRO</label>
                                                        <input type="text" name="entidad" className="form-control" id="entidad" value={entidad} onChange={(e) => setEntidad(e.target.value)} />
                                                        <div className="invalid-feedback visible">
                                                        {errorlist.entidad}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row" style={{marginTop: '30px'}}>
                                                <div className="col-md-6">
                                                    <button type="submit" className="btn btn-primary btn-block">
                                                        Guardar&nbsp;
                                                        {loading ? (<span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>) : null }
                                                        
                                                    </button>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                                </div>

                            </div>          
                            </div>

                        </div>
                    </section>
                </div>
                <Footer showToast={false} delay={0} />
            </div>
            
        );
    }

    return (
        <Loading />
    );
}
export default ParametrosRips;